// import React from 'react';
// import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import { Toaster } from 'sonner';
// import './App.css';
// import HomePage from './pages/HomePage';
// import AdminPage from './pages/AdminPage';
// import AdminLogin from './pages/AdminLogin';

// function App() {
//   return (
//     <div className="App">
//       <BrowserRouter>
//         <Routes>
//           <Route path="/" element={<HomePage />} />
//           <Route path="/admin/login" element={<AdminLogin />} />
//           <Route path="/admin" element={<AdminPage />} />
//         </Routes>
//       </BrowserRouter>
//       <Toaster position="top-right" richColors />
//     </div>
//   );
// }

// export default App;

import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import './App.css';
import HomePage from './pages/HomePage';
import AdminPage from './pages/AdminPage';
import AdminLogin from './pages/AdminLogin';
import BannerManagement from './pages/BannerManagement';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/banners" element={<BannerManagement />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
